export enum AssistantFilterPriority {
  HIGH = 1,
  SECOND = 2,
}
